(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("codemirror"), require("codemirror/addon/runmode/runmode"));
	else if(typeof define === 'function' && define.amd)
		define("abap", ["codemirror", "codemirror/addon/runmode/runmode"], factory);
	else if(typeof exports === 'object')
		exports["abap"] = factory(require("codemirror"), require("codemirror/addon/runmode/runmode"));
	else
		root["abap"] = factory(root["codemirror"], root["codemirror/addon/runmode/runmode"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__2__) {
return 